import { baseQuery } from '../baseQuery';
import { SkillLevel } from 'types';

type PutTechnicianSkillSetPayload = {
  techId: number;
  technicianSkillSetId: number;
  level: SkillLevel;
};

export const putTechnicianSkillSet = async (payload: PutTechnicianSkillSetPayload) => {
  const { techId, technicianSkillSetId, ...rest } = payload;
  const { data } = await baseQuery(`technicians/${techId}/skill-sets/${technicianSkillSetId}`, {
    type: 'PUT',
    body: {
      ...rest,
    },
  });

  return data;
};
